export default (v) => ({
  components: v.components ?? [
    {
      componentName: 'JmeText',
      text: 'This content is on hold.'
    }
  ],
  passThroughEndsAt: Date.parse(v.passThroughEndsAt) || Infinity,
  passThroughInAppContainer: v.passThroughInAppContainer === true, // default false
  passThroughInPreview: v.passThroughInPreview === true, // default false
  passThroughStartsAt: Date.parse(v.passThroughStartsAt) || Infinity,
  // we need to test for empty string, otherwise after clearing
  // string input, we would pass-through all with empty string
  // in ticket type name.
  passThroughTicketTypeName: v.passThroughTicketTypeName || null,
  passThroughUrl: v.passThroughUrl || '^/auth/login',
});
